// extracted by mini-css-extract-plugin
export default {"container":"LoaderStyles_container__lvQcx","loader":"LoaderStyles_loader__xEEF8","rotation":"LoaderStyles_rotation__7vNJY"};